import { createContext, useContext, useState } from "react";

export const translations = {
  en: {
    nav: {
      inventory: "Inventory",
      services: "Services",
      community: "Community",
      gallery: "Our Work",
      contact: "Contact",
      call: "Call Us",
    },
    hero: {
      eyebrow: "Family Auto Sales · Dealership & Auto Care",
      lines: ["Reliable Vehicles.", "Complete Auto Care.", "Built for Our Community."],
      sub: "Affordable cars, honest prices and full bilingual service — from tires and oil changes to collision repair and custom paint.",
      ctaPrimary: "See Our Work",
      ctaSecondary: "Book a Service",
      stats: [
        "Family Owned & Operated",
        "Salvage Titles Available",
        "Mon–Sat · 9 AM – 4 PM",
        "Hablamos Español",
      ],
    },
    marquee: [
      "HONDA",
      "TOYOTA",
      "JEEP",
      "CHEVROLET",
      "DODGE",
      "FORD",
      "SALVAGE TITLES",
      "REPAIR & PAINT",
      "OIL CHANGE",
      "NEW TIRES",
    ],
    inventory: {
      eyebrow: "Featured Inventory",
      title: "Affordable Cars, Ready to Roll",
      sub: "Sample vehicles from our lot — inventory changes weekly. Every car is inspected before it earns a spot here.",
      all: "All",
      cleanTitle: "Clean Title",
      salvageTitle: "Salvage Title",
      miles: "mi",
      details: "View Details",
      callAbout: "Call About This Car",
      note: "Sample listing — ask us what's on the lot today",
      transmission: "Transmission",
      engine: "Engine",
      condition: "Condition",
      titleLabel: "Title",
    },
    services: {
      eyebrow: "What We Do",
      title: "One Shop. Every Job.",
      sub: "Sales, service and bodywork under one roof — so you never have to drive across town twice.",
      items: [
        {
          title: "Vehicle Sales",
          desc: "Affordable, inspected cars, trucks and SUVs from the brands you trust — with guidance in your language, every step of the way.",
        },
        {
          title: "Tires — Sales & Change",
          desc: "New tires sold, mounted and balanced. Fast changeovers while you wait.",
        },
        {
          title: "Oil & Fluid Service",
          desc: "Quick oil changes and fluid checks that keep your engine young.",
        },
        {
          title: "Collision Repair",
          desc: "Crashed car? We straighten, weld and rebuild it back to road-ready.",
        },
        {
          title: "Paint & Bodywork",
          desc: "Full paint jobs, touch-ups and dent removal with factory-match color.",
        },
        {
          title: "Salvage Title Experts",
          desc: "We inspect, repair and clearly disclose salvage-title vehicles — quality at a lower price, no surprises.",
        },
      ],
    },
    community: {
      eyebrow: "Our Community",
      title: "Proudly Serving the Hispanic Community",
      sub: "Every customer is family. We explain everything clearly — in English or Spanish — so you always know exactly what you're paying for.",
      points: [
        "100% bilingual service — English & Spanish",
        "Honest prices, no hidden fees",
        "Help understanding titles & paperwork",
        "Family treatment, first visit to fiftieth",
      ],
      reviewsTitle: "Happy with our work?",
      reviewsLine: "Your Google review helps neighbors find an honest shop.",
      reviewsBtn: "Review Us on Google",
      testimonialsLabel: "What Neighbors Say",
      testimonials: [
        {
          quote:
            "They explained everything in Spanish and got my Civic back on the road the same week. Honest people.",
          name: "María G.",
          role: "Repeat customer",
        },
        {
          quote: "Bought my first truck here. Fair price, clear paperwork, zero pressure.",
          name: "José R.",
          role: "F-150 owner",
        },
        {
          quote:
            "Fixed my crash damage and the paint matches perfectly. You can't tell it ever happened.",
          name: "Ana L.",
          role: "Collision repair",
        },
      ],
    },
    faq: {
      eyebrow: "Good to Know",
      title: "Questions, Answered",
      sub: "Straight answers about titles, payments and salvage cars — in plain language.",
      items: [
        {
          q: "What is a salvage title?",
          a: "It means an insurance company once declared the vehicle a total loss and it was later repaired. We disclose the title status of every car up front — and it's a big reason these vehicles cost less.",
        },
        {
          q: "Are salvage-title cars safe to drive?",
          a: "Every salvage vehicle we sell is repaired and inspected in our own shop before it goes on the lot. Ask us and we'll walk you through exactly what was repaired.",
        },
        {
          q: "Do you offer financing or payment options?",
          a: "Every situation is different. Call us or stop by and we'll sit down with you — in English or Spanish — to find an option that fits your budget.",
        },
        {
          q: "Do you inspect cars before selling them?",
          a: "Yes. Every vehicle on our lot is inspected before it's listed, no matter the title type.",
        },
        {
          q: "Can you fix and paint my current car instead?",
          a: "Absolutely — we're a full service shop: collision repair, paint, tires and oil changes. Bring your car by for an honest estimate.",
        },
      ],
    },
    gallery: {
      eyebrow: "Our Work",
      title: "Before & After",
      sub: "Crash-repair and paint transformations from our shop. Drag the handle to compare.",
      before: "Before",
      after: "After",
      note: "Sample photo shown — real shop work photos coming soon",
      lotTitle: "Straight From Our Lot",
      lotSub: "Real photos from 8670 Shannon Rd — the shop, the paint bay and the cars. No stock images here.",
    },
    contact: {
      eyebrow: "Visit Us",
      title: "Hours & Contact",
      hoursTitle: "Hours of Operation",
      days: [
        { d: "Monday – Saturday", h: "9:00 AM – 4:00 PM" },
        { d: "Sunday", h: "Closed" },
      ],
      phoneLabel: "Call or Text",
      addressLabel: "Find Us",
      directions: "Get Directions",
      formTitle: "Request a Call Back",
      name: "Your name",
      phone: "Phone number",
      service: "What do you need?",
      serviceOptions: [
        "Buy a vehicle",
        "Tires — new or change",
        "Oil change",
        "Collision repair",
        "Paint & bodywork",
        "Something else",
      ],
      message: "Tell us about your vehicle (optional)",
      send: "Send Request",
      sending: "Sending...",
      sent: "Request received — we'll call you back!",
      error: "Something went wrong. Please call us instead.",
    },
    footer: {
      tagline: "Affordable cars and honest auto care for our community.",
      explore: "Explore",
      servicesTitle: "Services",
      hoursTitle: "Hours",
      hoursLine: "Mon–Sat · 9 AM – 4 PM",
      closedLine: "Sunday · Closed",
      rights: "All rights reserved.",
      langLabel: "Language",
    },
  },
  es: {
    nav: {
      inventory: "Inventario",
      services: "Servicios",
      community: "Comunidad",
      gallery: "Galería",
      contact: "Contacto",
      call: "Llámanos",
    },
    hero: {
      eyebrow: "Family Auto Sales · Venta y Cuidado Automotriz",
      lines: ["Vehículos Confiables.", "Cuidado Automotriz Completo.", "Para Nuestra Comunidad."],
      sub: "Autos accesibles, precios honestos y servicio 100% bilingüe — desde llantas y cambio de aceite hasta reparación de choques y pintura.",
      ctaPrimary: "Ver Nuestro Trabajo",
      ctaSecondary: "Agendar Servicio",
      stats: [
        "Negocio Familiar",
        "Títulos de Salvamento",
        "Lun–Sáb · 9 AM – 4 PM",
        "We Speak English",
      ],
    },
    marquee: [
      "HONDA",
      "TOYOTA",
      "JEEP",
      "CHEVROLET",
      "DODGE",
      "FORD",
      "TÍTULOS DE SALVAMENTO",
      "REPARACIÓN Y PINTURA",
      "CAMBIO DE ACEITE",
      "LLANTAS NUEVAS",
    ],
    inventory: {
      eyebrow: "Inventario Destacado",
      title: "Autos Accesibles, Listos para Rodar",
      sub: "Vehículos de muestra de nuestro lote — el inventario cambia cada semana. Cada auto es inspeccionado antes de ganarse un lugar aquí.",
      all: "Todos",
      cleanTitle: "Título Limpio",
      salvageTitle: "Título de Salvamento",
      miles: "mi",
      details: "Ver Detalles",
      callAbout: "Llamar por Este Auto",
      note: "Ejemplo — pregúntanos qué hay en el lote hoy",
      transmission: "Transmisión",
      engine: "Motor",
      condition: "Condición",
      titleLabel: "Título",
    },
    services: {
      eyebrow: "Lo Que Hacemos",
      title: "Un Solo Taller. Todo el Trabajo.",
      sub: "Ventas, servicio y carrocería bajo el mismo techo — para que nunca tengas que cruzar la ciudad dos veces.",
      items: [
        {
          title: "Venta de Vehículos",
          desc: "Autos, camionetas y SUVs accesibles e inspeccionados de las marcas que conoces — con orientación en tu idioma, paso a paso.",
        },
        {
          title: "Llantas — Venta y Cambio",
          desc: "Llantas nuevas, montadas y balanceadas. Cambios rápidos mientras esperas.",
        },
        {
          title: "Cambio de Aceite",
          desc: "Cambios de aceite rápidos y revisión de fluidos que mantienen tu motor joven.",
        },
        {
          title: "Reparación de Choques",
          desc: "¿Chocaste? Enderezamos, soldamos y reconstruimos tu auto hasta dejarlo listo para el camino.",
        },
        {
          title: "Pintura y Carrocería",
          desc: "Pintura completa, retoques y eliminación de abolladuras con color igualado de fábrica.",
        },
        {
          title: "Expertos en Títulos de Salvamento",
          desc: "Inspeccionamos, reparamos y declaramos claramente los vehículos de salvamento — calidad a menor precio, sin sorpresas.",
        },
      ],
    },
    community: {
      eyebrow: "Nuestra Comunidad",
      title: "Orgullosamente Sirviendo a la Comunidad Hispana",
      sub: "Cada cliente es familia. Te lo explicamos todo con claridad — en inglés o español — para que siempre sepas exactamente por qué pagas.",
      points: [
        "Servicio 100% bilingüe — inglés y español",
        "Precios honestos, sin cargos ocultos",
        "Ayuda con títulos y papeleo",
        "Trato de familia, de la primera a la quincuagésima visita",
      ],
      reviewsTitle: "¿Contento con nuestro trabajo?",
      reviewsLine: "Tu reseña en Google ayuda a los vecinos a encontrar un taller honesto.",
      reviewsBtn: "Déjanos una Reseña",
      testimonialsLabel: "Lo Que Dicen los Vecinos",
      testimonials: [
        {
          quote:
            "Me explicaron todo en español y mi Civic quedó listo la misma semana. Gente honesta.",
          name: "María G.",
          role: "Cliente frecuente",
        },
        {
          quote: "Compré mi primera troca aquí. Precio justo, papeleo claro, cero presión.",
          name: "José R.",
          role: "Dueño de F-150",
        },
        {
          quote: "Repararon el choque y la pintura quedó perfecta. No se nota que pasó nada.",
          name: "Ana L.",
          role: "Reparación de choque",
        },
      ],
    },
    faq: {
      eyebrow: "Bueno Saber",
      title: "Preguntas Frecuentes",
      sub: "Respuestas claras sobre títulos, pagos y autos de salvamento — sin rodeos.",
      items: [
        {
          q: "¿Qué es un título de salvamento?",
          a: "Significa que una aseguradora declaró el vehículo como pérdida total y después fue reparado. Nosotros te decimos el estado del título desde el principio — y es una gran razón por la que estos autos cuestan menos.",
        },
        {
          q: "¿Son seguros los autos con título de salvamento?",
          a: "Cada vehículo de salvamento que vendemos es reparado e inspeccionado en nuestro propio taller antes de llegar al lote. Pregúntanos y te explicamos exactamente qué se reparó.",
        },
        {
          q: "¿Ofrecen financiamiento u opciones de pago?",
          a: "Cada situación es diferente. Llámanos o visítanos y nos sentamos contigo — en inglés o español — para encontrar una opción que se ajuste a tu presupuesto.",
        },
        {
          q: "¿Inspeccionan los autos antes de venderlos?",
          a: "Sí. Cada vehículo de nuestro lote es inspeccionado antes de ponerse a la venta, sin importar el tipo de título.",
        },
        {
          q: "¿Pueden reparar y pintar mi carro actual?",
          a: "Claro que sí — somos un taller completo: reparación de choques, pintura, llantas y cambio de aceite. Trae tu carro para un estimado honesto.",
        },
      ],
    },
    gallery: {
      eyebrow: "Nuestro Trabajo",
      title: "Antes y Después",
      sub: "Transformaciones de reparación de choques y pintura de nuestro taller. Arrastra el control para comparar.",
      before: "Antes",
      after: "Después",
      note: "Foto de muestra — fotos reales del taller próximamente",
      lotTitle: "Directo de Nuestro Lote",
      lotSub: "Fotos reales de 8670 Shannon Rd — el taller, el área de pintura y los autos. Nada de fotos de archivo.",
    },
    contact: {
      eyebrow: "Visítanos",
      title: "Horario y Contacto",
      hoursTitle: "Horario de Atención",
      days: [
        { d: "Lunes – Sábado", h: "9:00 AM – 4:00 PM" },
        { d: "Domingo", h: "Cerrado" },
      ],
      phoneLabel: "Llama o Escribe",
      addressLabel: "Encuéntranos",
      directions: "Cómo Llegar",
      formTitle: "Solicita una Llamada",
      name: "Tu nombre",
      phone: "Número de teléfono",
      service: "¿Qué necesitas?",
      serviceOptions: [
        "Comprar un vehículo",
        "Llantas — nuevas o cambio",
        "Cambio de aceite",
        "Reparación de choque",
        "Pintura y carrocería",
        "Otra cosa",
      ],
      message: "Cuéntanos sobre tu vehículo (opcional)",
      send: "Enviar Solicitud",
      sending: "Enviando...",
      sent: "¡Solicitud recibida — te llamaremos pronto!",
      error: "Algo salió mal. Por favor llámanos.",
    },
    footer: {
      tagline: "Autos accesibles y cuidado honesto para nuestra comunidad.",
      explore: "Explorar",
      servicesTitle: "Servicios",
      hoursTitle: "Horario",
      hoursLine: "Lun–Sáb · 9 AM – 4 PM",
      closedLine: "Domingo · Cerrado",
      rights: "Todos los derechos reservados.",
      langLabel: "Idioma",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
